import { getLanguageCode } from '../utilities';

export default class AvailabilityWatchListClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/api-availability-watchlist-' + languageCode;
    }

    get uri()
    {
        return this._uri;
    }

    /**
	 * GET
	 */

    /**
	 * @param productNumber
	 * @returns {Promise<Response>}
	 */
    isProductNumberOnWatchList(productNumber)
    {
        return fetch(this._uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                'productNumber': productNumber
            }
        });
    }

    /**
	 * POST
	 */

    /**
	 * @param productNumber
	 * @returns {Promise<Response>}
	 */
    addProductNumberToWatchList(productNumber)
    {
        let data = new FormData();
        data.append('addToWatchlist', true);
        data.append('productNumber', productNumber);

        return fetch(this._uri, {
            method: 'POST',
            body: data
        });
    }

    /**
	 * @param productNumber
	 * @returns {Promise<Response>}
	 */
    removeProductNumberFromWatchList(productNumber)
    {
        let data = new FormData();
        data.append('removeFromWatchlist', true);
        data.append('productNumber', productNumber);

        return fetch(this._uri, {
            method: 'POST',
            body: data
        });
    }
}
